import { logout as logoutApi } from '../api/auth';
import { changeSurveyField } from '../utils/surveys';
import { clearUserDataAction } from './user';
import {
    BUYER_EMAIL_FIELD,
    BUYER_FIRST_NAME_FIELD,
    BUYER_LAST_NAME_FIELD,
    getFieldName,
    CANNED_QUESTION_FIRST_NAME,
    CANNED_QUESTION_EMAIL_ADDRESS,
    CANNED_QUESTION_LAST_NAME,
} from '../containers/checkout/constants';

export const CLEAR_USER_DATA = 'clearUserData';
export const clearUserData = () => ({
    type: CLEAR_USER_DATA,
});

export const logout = () => (dispatch, getState) => {
    const {
        app: { user },
        form: {
            checkoutForm: { values },
        },
        order: { attendees },
    } = getState();

    // TODO: This duplication of clearing the user data is being handled in
    // a separate diff: https://github.com/eventbrite/eb-ui/pull/4993
    dispatch(clearUserDataAction());
    dispatch(clearUserData());
    dispatch(changeSurveyField(BUYER_EMAIL_FIELD, null));
    dispatch(changeSurveyField(BUYER_FIRST_NAME_FIELD, null));
    dispatch(changeSurveyField(BUYER_LAST_NAME_FIELD, null));
    dispatch(changeSurveyField('payment.vaultId', null));

    const ticketOneFieldValues = values[attendees[0].id];

    if (
        ticketOneFieldValues &&
        ticketOneFieldValues[CANNED_QUESTION_EMAIL_ADDRESS] === user.email &&
        ticketOneFieldValues[CANNED_QUESTION_FIRST_NAME] === user.firstName &&
        ticketOneFieldValues[CANNED_QUESTION_LAST_NAME] === user.lastName
    ) {
        dispatch(
            changeSurveyField(
                getFieldName(attendees[0].id, CANNED_QUESTION_EMAIL_ADDRESS),
                null,
            ),
        );
        dispatch(
            changeSurveyField(
                getFieldName(attendees[0].id, CANNED_QUESTION_FIRST_NAME),
                null,
            ),
        );
        dispatch(
            changeSurveyField(
                getFieldName(attendees[0].id, CANNED_QUESTION_LAST_NAME),
                null,
            ),
        );
    }

    return logoutApi();
};
